import { FeatureType } from "../@shared/types";
import React from "react";

export const TestTypeContext = React.createContext(FeatureType.Availability);
